import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatMessage } from '../models/chat-message.model';
import { ChatMessageFromEnum } from '../models/chat-message-from.enum';

@Component({
  selector: 'nida-web-chat-message',
  imports: [CommonModule],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
})
export class ChatMessageComponent implements OnInit {
  @Input() chatMessage: ChatMessage;

  @HostBinding('class.from-me') fromMeClass = false;
  @HostBinding('class.from-them') fromThemClass = false;

  ngOnInit(): void {
    this.fromMeClass = this.chatMessage?.from === ChatMessageFromEnum.ME;
    this.fromThemClass = this.chatMessage?.from === ChatMessageFromEnum.THEM;
  }

  public isToday(inputDate: Date): boolean {
    if (!inputDate) {
      return false;
    }

    const today = new Date();
    return (
      inputDate.getDate() == today.getDate() && inputDate.getMonth() == today.getMonth() && inputDate.getFullYear() == today.getFullYear()
    );
  }

  protected readonly ChatMessageFromEnum = ChatMessageFromEnum;
}
